"use client";

import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogTrigger,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from "../ui/dialog";
import { cn } from "../lib/utils";
import { DialogClose } from "@radix-ui/react-dialog";

type DialogSuiteProps = {
  /** The element that opens the dialog */
  trigger?: React.ReactNode;
  /** The dialog body content */
  children?: React.ReactNode;
  /** Optional title & description */
  title?: string;
  description?: string;
  /** Optional footer (e.g. buttons) */
  footer?: React.ReactNode;
  /** Optional className override for content */
  contentClassName?: string;
  /** Controlled open state */
  open?: boolean;
  /** Callback for open state change */
  onOpenChange?: (open: boolean) => void;
};

export function DialogSuite({
  trigger,
  children,
  title,
  description,
  footer,
  contentClassName,
  open,
  onOpenChange,
}: DialogSuiteProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {trigger && <DialogTrigger asChild>{trigger}</DialogTrigger>}
      <DialogContent
        className={cn(
          "sm:max-w-md max-h-[90vh] flex flex-col p-0 gap-0 overflow-hidden",
          contentClassName,
        )}
      >
        {(title || description) && (
          <DialogHeader
            className={cn("p-6", children ? "border-b pb-2" : "pb-0")}
          >
            {title && <DialogTitle className="text-left">{title}</DialogTitle>}
            {description && (
              <DialogDescription className="text-left">
                {description}
              </DialogDescription>
            )}
          </DialogHeader>
        )}

        <div className="flex-1 overflow-y-auto p-6">{children}</div>

        {footer && (
          <DialogFooter
            className={cn(
              "p-6 sm:justify-start ",
              children ? "border-t pt-2" : "pt-0",
            )}
          >
            {footer}
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
}

export { DialogClose };
